import React from 'react';
import { IconButton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
const CheckButton = ({ isSelected, toggleSelection }) => {
  return (
    <IconButton
      variant="contained"
      disableRipple={true}
      onClick={toggleSelection}
      sx={{
        width: 25,
        height: 25,
        border: '2px solid',
        borderColor: isSelected ? 'success.main' : 'grey.400',
        backgroundColor: isSelected ? 'success.light' : 'transparent',
        color: isSelected ? 'success.main' : 'grey.600',
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: 'success.main',
          backgroundColor: isSelected ? 'success.main' : 'action.hover',
          color: isSelected ? 'white' : 'success.main',
        },
      }}
    >
      <CheckIcon />
    </IconButton>
  );
};

export default CheckButton;
